import ofxParser from 'node-ofx-parser';
// import ofxParser from '@wademason/ofx';
import * as fs from 'fs';

export function parseXmlOfxToJson(file)
{
    // const responseFile = fs.readFileSync(file, 'base64');
    return ofxParser.parse(file);
}